import {createContext, useCallback, useContext, useEffect, useRef, useState} from 'react'

import {useErrorHandler} from '../../../../../_metronic/helpers/ErrorHandler'
import * as ReportService from '../services/ReportService'
import {isNdviReportActive} from './ndviReportStatus'

const NDVIReportContext = createContext()

export function useNDVIReportContext() {
  return useContext(NDVIReportContext)
}

export const NDVIReportConsumer = NDVIReportContext.Consumer

export function NDVIReportProvider({children}) {
  const {errorHandler} = useErrorHandler()
  const [loading, setLoading] = useState(true)
  const [reports, setReports] = useState([])
  const mountedRef = useRef(false)
  const pollTimeoutRef = useRef(null)
  const errorHandlerRef = useRef(errorHandler)

  errorHandlerRef.current = errorHandler

  const load = useCallback((notLoad) => {
    if (pollTimeoutRef.current) {
      clearTimeout(pollTimeoutRef.current)
      pollTimeoutRef.current = null
    }

    if (!notLoad) {
      setLoading(true)
    }

    errorHandlerRef.current(ReportService.list(0, 20)).then((res) => {
      if (!mountedRef.current) {
        return
      }

      if (res.ok) {
        setReports(res.data.ndvi_reports)
        if (res.data.ndvi_reports.some(({status}) => isNdviReportActive(status))) {
          pollTimeoutRef.current = setTimeout(() => load(true), 5000)
        }
      }

      setLoading(false)
    })
  }, [])

  useEffect(() => {
    mountedRef.current = true
    load()

    return () => {
      mountedRef.current = false
      if (pollTimeoutRef.current) {
        clearTimeout(pollTimeoutRef.current)
      }
    }
  }, [load])

  const value = {
    reports,
    loading,
    load,
  }

  return (
    <>
      <NDVIReportContext.Provider value={value}>{children}</NDVIReportContext.Provider>
    </>
  )
}
